import { render, staticRenderFns } from "./CreateEventTickets.vue?vue&type=template&id=511e32ad&scoped=true"
import script from "./CreateEventTickets.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventTickets.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventTickets.vue?vue&type=style&index=0&id=511e32ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e32ad",
  null
  
)

export default component.exports